import React from 'react'
import { AlertCircleIcon } from 'src/editor/shared/icons/alert-circle-icon'
import {
  DialogWindow,
  DialogWindowIconThemeEnum,
  DialogWindowProps,
} from './dialog-window'

export interface ConfirmationDialogWindowProps
  extends Omit<DialogWindowProps, 'icon' | 'iconTheme'> {}

export const ConfirmationDialogWindow = (
  props: ConfirmationDialogWindowProps,
) => {
  return (
    <DialogWindow
      icon={<AlertCircleIcon />}
      iconTheme={DialogWindowIconThemeEnum.Confirmation}
      {...props}
    />
  )
}
